import type { ReactNode } from 'react';
import cx from 'clsx';
import IconChevronBottomOutlined from '@repo/monochrome-icons/icon-chevron-bottom-outlined';
import IconChevronTopOutlined from '@repo/monochrome-icons/icon-chevron-top-outlined';
import styles from './multi-select-trigger.module.css';

export interface MultiSelectTriggerProps {
  selectedText: string;
  placeholder: string;
  isOpen: boolean;
  selectedCount: number;
  secondaryText?: string;
  selectedValueClassName?: string;
  withClear?: boolean;
}

export function MultiSelectTrigger({
  selectedText,
  placeholder,
  isOpen,
  selectedCount,
  secondaryText,
  selectedValueClassName,
  withClear = false,
}: MultiSelectTriggerProps): ReactNode {
  return (
    <>
      <div
        className={cx(
          styles.inputValue,
          withClear && styles.inputValueWithClear,
          selectedValueClassName
        )}
      >
        {selectedCount > 0 && selectedText ? (
          <span className={styles.text}>
            <span className={styles.selectedText}>{selectedText}</span>
          </span>
        ) : (
          <span className={styles.placeholder}>{placeholder}</span>
        )}
      </div>

      {secondaryText ? <span className={styles.secondary}>{secondaryText}</span> : null}
      {!withClear && (isOpen ? <IconChevronTopOutlined /> : <IconChevronBottomOutlined />)}
    </>
  );
}
